"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 60 * 1000,      // 1 hour default
            gcTime: 2 * 60 * 60 * 1000,     // 2 hours garbage collection
            refetchOnWindowFocus: false,    // Don't refetch on tab focus
            refetchOnReconnect: false,      // Don't refetch on network reconnect
            retry: 1,                       // Only retry once on failure
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
          },
        }}
      />
    </QueryClientProvider>
  );
}
